import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, permissions, isAdmin } = useContext(AuthContext);

  // Yönlendirilen sayfayı URL'den al
  const from = location.state?.from || '/';

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4 py-12">
      <div className="max-w-md w-full space-y-8 p-6 bg-white rounded-xl shadow-lg">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100">
            <svg className="h-10 w-10 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">Erişim Engellendi</h2>
          <p className="mt-2 text-sm text-gray-600">
            Bu sayfaya erişim için gerekli izinlere sahip değilsiniz.
          </p>
        </div>

        <div className="mt-8 border-t border-gray-200 pt-6 space-y-4">
          <div>
            <h3 className="text-sm font-medium text-gray-500">Kullanıcı Bilgileri</h3>
            <p className="text-base font-medium text-gray-900">{user?.username || "Bilinmiyor"}</p>
            <p className="text-sm text-gray-500">{isAdmin ? "Admin Yetkisi Var" : "Admin Yetkisi Yok"}</p>
          </div>

          <div>
            <h3 className="text-sm font-medium text-gray-500">İstenilen Sayfa</h3>
            <p className="text-base font-medium text-gray-900 break-all">{from}</p>
          </div>

          <div className="space-y-2">
            <button
              onClick={() => navigate('/')}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Ana Sayfaya Dön
            </button>
            <button
              onClick={() => navigate(-1)}
              className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Geri Dön
            </button>
          </div>
        </div>
      </div>
      
      {/* Debug izin bilgileri */}
      <div className="mt-8 max-w-md w-full bg-white shadow-lg rounded-lg p-4">
        <h3 className="text-lg font-semibold mb-2">İzin Detayları</h3>
        {permissions.length > 0 ? (
          <ul className="list-disc pl-5 space-y-1">
            {permissions.map((perm, idx) => (
              <li key={idx}>
                <strong className="text-gray-700">{perm.resource}:</strong>{' '}
                <span className="text-gray-600">{perm.actions.join(', ')}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-red-500">Kullanıcı hiçbir kaynak için izne sahip değil!</p>
        )}
      </div>
    </div>
  );
};

export default Unauthorized;
